import React from "react";
import { useGameMachine } from "../hooks/useGameMachine.js";
import { selectIsWorldFrozen } from "../../machines/gameMachine.js";

/**
 * U01 — gear-icon menu affordance in the top-left corner.
 *
 * Doubles as a tap-target on mobile (no hardware Escape) and a visible
 * "open menu" cue on desktop. Hidden while the menu is already open or
 * the world is frozen (dialogue / shop / overlay owns the surface).
 *
 * Upper-left keeps it clear of the mini-map and other top-right HUD
 * elements. The name "EscChip" is retained from U01 but the icon is
 * now a gear — same button, different skin.
 */
export function EscChip() {
  const [snapshot, send] = useGameMachine();

  const menuOpen = snapshot.matches("menu");
  const frozen = selectIsWorldFrozen(snapshot);
  const exploringOrCombat =
    snapshot.matches("exploring") || snapshot.matches("combat");

  if (!exploringOrCombat || menuOpen || frozen) return null;

  return (
    <button
      onClick={() => send({ type: "OPEN_MENU" })}
      aria-label="Open menu"
      title="Menu (Esc)"
      style={{
        position: "absolute",
        top: "calc(12px + env(safe-area-inset-top, 0px))",
        left: "calc(12px + env(safe-area-inset-left, 0px))",
        pointerEvents: "auto",
        background: "rgba(20, 22, 32, 0.85)",
        border: "1px solid rgba(255,255,255,0.25)",
        borderRadius: 6,
        width: 36,
        height: 36,
        padding: 0,
        color: "rgba(255,255,255,0.9)",
        fontFamily: "monospace",
        fontSize: 20,
        lineHeight: 1,
        cursor: "pointer",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 50,
      }}
    >
      <span aria-hidden>⚙</span>
    </button>
  );
}
